import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import barChart from '../../../assets/icons/bar-chart-square-02.png';
import barChartIcon from '../../../assets/icons/bar_chart_icon.png';
import advanceSearch from '../../../assets/icons/advance_search.svg';
import advanceSearchIcon from '../../../assets/icons/advance_search_icon.svg';
import CalculatorOutlined from '../../../assets/icons/CalculatorOutlined.png';
import CalculatorOutlined_active from '../../../assets/icons/CalculatorOutlined_active.png';
import request_approval_off from '../../../assets/icons/request_approval_off.png';
import request_approval_on from '../../../assets/icons/request_approval_on.png';
import quarterly_input from '../../../assets/icons/quarterly_input.png';
import quarterly_input_off from '../../../assets/icons/quarterly_input_off.png';
import { useDispatch } from 'react-redux';
import { logout } from '../../../features/login/redux/slice.js';
import { Button, Modal, message } from 'antd';
import LocalStorage from '../../../utilities/localStorage.js';
import trainingVideoIcon from '@assets/icons/traininfVideo.svg';
import trainingVideoActiveIcon from '@assets/icons/trainingVideo_active.svg';
import userManualIcon from '@assets/icons/userManual.svg';
import userManualActiveIcon from '@assets/icons/userManual_active.svg';

const Sidebar = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const user_details = LocalStorage.getItem('bbs_user');
  //console.log(user_details?.user?.Role?.role)

  const dispatch = useDispatch();

  const handleLogout = () => {
    // Show confirmation dialog
    Modal.confirm({
      title: 'Are you sure you want to log out?',
      onOk: () => {
        // Step 1: Clear the localStorage
        localStorage.clear();

        // Step 2: Show success message after logout
        message.success('Logged out successfully');

        // Step 3: Redirect to the login page
        navigate('/login');
      },
    });
  };
  return (
    <>
      <button
        className="sm:hidden fixed top-4 left-4 z-50 bg-[#1C4E9D] text-white p-2 rounded-full shadow-lg"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? '✖' : '☰'}
      </button>

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full bg-white border-r-0 border-[#e0e7ff] transform transition-transform duration-300 ease-in-out z-40 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } sm:translate-x-0 sm:relative sm:flex sm:w-[200px] p-[5px]`}
      >
        <ul className="list-none p-[5px] m-0 flex flex-col w-[184px]">
          {user_details?.user?.Role?.role === 'REQUESTER' && (
            <li className="py-[8px]">
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center no-underline gap-[10px] p-[10px_5px]  rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={isActive ? barChart : barChartIcon} // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="w-[20px] h-[20px]"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      Dashboard
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user_details?.user?.Role?.role === 'MANAGER' && (
            <li className="py-[8px]">
              <NavLink
                to="/leadership-dashboard"
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center no-underline gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={isActive ? barChart : barChartIcon} // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="w-[20px] h-[20px]"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      Dashboard
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user_details?.user?.Role?.role === 'MANAGER' && (
            <li className="py-[8px]">
              <NavLink
                to="/dashboard"
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center no-underline gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={isActive ? barChart : barChartIcon} // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="w-[20px] h-[20px]"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      Approval Dashboard
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user_details?.user?.Role?.role === 'REQUESTER' && (
            <li className="py-[8px]">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center no-underline  gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
                to="/request-approval"
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={
                        isActive ? request_approval_on : request_approval_off
                      } // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="w-[20px] h-[20px]"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      Request Approval
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user_details?.user?.Role?.role === 'VIEWER' && (
            <li className="py-[8px]">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center font-medium no-underline  gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
                to="/viewer/dashboard"
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={isActive ? barChart : barChartIcon} // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="w-[20px] h-[20px]"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      Dashboard
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user_details?.user?.Role?.role === 'VIEWER' && (
            <li className="py-[8px]">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center font-medium no-underline  gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
                to="/viewer/tool-adherence"
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={
                        isActive ? request_approval_on : request_approval_off
                      } // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="w-[20px] h-[20px]"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      Tool Adherence
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          )}
          {user_details?.user?.Role?.role === 'REQUESTER' ||
          user_details?.user?.Role?.role === 'MANAGER' ? (
            <li className="py-[8px]">
              <NavLink
                to="/quarterly-input"
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center no-underline gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={isActive ? quarterly_input : quarterly_input_off} // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="w-[20px] h-[20px]"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      Quarterly Input
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          ) : null}

          {user_details?.user?.Role?.role === 'REQUESTER' ||
          user_details?.user?.Role?.role === 'MANAGER' ? (
            <li className="py-[8px]">
              <NavLink
                to="/training-manual"
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center no-underline gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={isActive ? userManualActiveIcon : userManualIcon} // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="h-5 mt-0.5"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      User Manual
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          ) : null}

          {user_details?.user?.Role?.role === 'REQUESTER' ||
          user_details?.user?.Role?.role === 'MANAGER' ? (
            <li className="py-[8px]">
              <NavLink
                to="/training-video"
                className={({ isActive }) =>
                  isActive
                    ? 'flex items-center no-underline gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                    : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
                }
              >
                {({ isActive }) => (
                  <>
                    <img
                      src={
                        isActive ? trainingVideoActiveIcon : trainingVideoIcon
                      } // Conditionally render the image based on isActive
                      alt="Dashboard Icon"
                      className="h-5 mt-0.5"
                    />
                    <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                      Training Video
                    </p>
                  </>
                )}
              </NavLink>
            </li>
          ) : null}

          {/* <li className="py-[8px]">
            <NavLink
              to="/advance-search"
              className={({ isActive }) =>
                isActive
                  ? 'flex items-center no-underline gap-[10px] p-[10px_5px] rounded-[5px] bg-[#F6FAFF] h-[36px] w-[174px] shadow-[inset_0px_0px_4px_0px_rgba(0,0,0,0.15)] border-r-[3px] border-[#1C4E9D] text-[#1C4E9D]'
                  : 'flex items-center no-underline text-[#667085] gap-[10px] p-[10px_5px] rounded-[5px] hover:bg-[#f0f0f0]'
              }
            >
              {({ isActive }) => (
                <>
                  <img
                    src={isActive ? advanceSearchIcon : advanceSearch} // Conditionally render the image based on isActive
                    alt="Advance Search Icon"
                    className="w-[20px] h-[20px]"
                  />
                  <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-[12.5px] p-[3px] m-0">
                    Advance Search
                  </p>
                </>
              )}
            </NavLink>
          </li> */}
        </ul>
      </div>

      {/* Overlay for small screens */}
      {isOpen && (
        <div
          className="fixed inset-0 z-30 bg-black bg-opacity-30 sm:hidden"
          onClick={() => setIsOpen(false)}
        ></div>
      )}
    </>
  );
};

export default Sidebar;
